import React from "react"
import { useTranslation } from "react-i18next"
import { cn } from "../../../lib"

const TABS = [
  { key: "tour", labelKey: "filter.tours", href: "/book/filter/packages" },
  { key: "bus", labelKey: "dashboard.bus_tickets", href: "/book/filter/bus" },
  { key: "avia", labelKey: "dashboard.avia_tickets", href: "/book/filter/transport" },
  { key: "excursion", labelKey: "modules.travel_excursion", href: "/book/filter_excursion/index" },
  { key: "insurance", labelKey: "admin.insurance", href: "/book/filter_insurance/index" },
  { key: "service", labelKey: "admin.service_search", href: "/book/service/search" },
]

const SearchTabs = ({ active }) => {
  const { t } = useTranslation()

  return (
    <div className="w-fit bg-text-secondary/10 rounded-t-lg overflow-hidden">
      <div className="flex flex-wrap">
        {TABS.map((tab, index) => {
          const isActive = tab.key === active
          const isFirst = index === 0
          const isLast = index === TABS.length - 1

          return (
            <a
              key={tab.key}
              href={tab.href}
              aria-current={isActive ? "page" : undefined}
              className={cn(
                "whitespace-nowrap px-4 py-3 text-sm font-semibold transition-colors no-underline",
                isFirst && "rounded-tl-lg",
                isLast && "rounded-tr-lg",
                isActive ? "bg-white text-orange-600" : "text-gray-700 hover:bg-white"
              )}
            >
              {t(tab.labelKey)}
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default SearchTabs
